<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="schools"
      item-key="id"
      class="elevation-0"
      hide-default-footer
      :loading="loading"
      :items-per-page="-1"
    >
      <template v-slot:item.name="{ item }">
        <router-link :to="`/detail/colleges/${item.id}`" class="mx-1">
          <span>{{ item.name }}</span>
        </router-link>
      </template>

      <template v-slot:item.active="{ item }">
        <span v-if="item.active" class="green--text font-weight-bold">
          {{ $t('conglomerates.active') }}
        </span>
        <span v-else class="orange--text darken-2 font-weight-bold">
          {{ $t('conglomerates.inactive') }}
        </span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon small @click="confirmUnlink(item)">
          <v-icon small>mdi-link-variant-off</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="showUnlinkDialog" max-width="500px">
      <v-card>
        <v-card-title class="text-h6">
          {{ $t('conglomerates.unlink_school') }}
        </v-card-title>
        <v-card-text>
          {{ $t('conglomerates.unlink_confirmation') }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showUnlinkDialog = false">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn color="error" text @click="performUnlink">
            {{ $t('conglomerates.unlink_school') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
const headerBuilder = (text, value, sortable = true) => ({
  text,
  value,
  sortable,
  align: 'center',
});

export default {
  name: 'ConglomerateSchoolsTable',
  props: {
    schools: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    showUnlinkDialog: false,
    selectedSchool: null,
  }),
  computed: {
    headers() {
      return [
        headerBuilder('ID', 'id'),
        headerBuilder(this.$t('conglomerates.school_name'), 'name'),
        headerBuilder(this.$t('conglomerates.status'), 'active'),
        headerBuilder(this.$t('conglomerates.actions'), 'actions', false),
      ];
    },
  },
  methods: {
    confirmUnlink(school) {
      this.selectedSchool = school;
      this.showUnlinkDialog = true;
    },
    performUnlink() {
      if (this.selectedSchool) {
        this.$emit('unlink', this.selectedSchool.id);
        this.showUnlinkDialog = false;
        this.selectedSchool = null;
      }
    },
  },
};
</script>
